import { Component, EventEmitter, OnInit, Input, Output, Attribute } from '@angular/core';

@Component({
  selector: 'app-botao',
  templateUrl: './botao.component.html',
  styleUrls: ['./botao.component.css']
})
export class BotaoComponent implements OnInit {

  constructor() { }

  @Input() tipo: string = 'button';
  @Input() classe: string = '';
  @Input() desabilitado: boolean = false;
  @Input() executando: boolean = false;
  @Input() texto: string = null;
  @Input() textoExecutando: string = 'Aguarde...';
  @Input() icone: string = null;
  @Input() posicaoDoIcone: string;
  @Input() matSuffix: string;
  @Output() clique = new EventEmitter();
  @Input() tamanhoDoTexto: string = '1rem';


  public hideClass = 'd-none d-sm-inline';
  public iconeExecutando = 'fa-solid fa-ellipsis fa-beat-fade';

  ngOnInit() {

    this.classe = 'btn ' + (this.matSuffix === '' ? 'btn-link suffix ' : '') + this.classe ;

    if (this.posicaoDoIcone && !this.icone) {
      if (this.posicaoDoIcone === 'esquerda') {
        this.icone = 'fas fa-chevron-left';
      } else {
        this.icone = 'fas fa-chevron-right';
      }
    }
  }

  click() {
    this.clique.emit();
  }

}

